import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import banner1 from "../assets/Upload/Banner/b76e04ab-ee42-4925-89b4-c80ffca9ad58.jpg";
import banner2 from "../assets/Upload/Banner/3cc20623-d213-4bff-9050-252dbcdd0ca1.jpg";
import ludhianalogo from "../assets/images/logo/westbridge_seal.png";
import Background from "../assets/images/bg/foravni.jpg";
import Study from "./Study";
import Testimonial from "./Testimonial";
import { Carousel, Modal, Button } from "react-bootstrap";
import axios from "axios";

export default function Home() {
  const [banners, setBanners] = useState([]);
  const [dataDesc, setData] = useState("");
  const [title, setTitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [counted, setCounted] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/cms/slug/welcome-to-millennium-school`
        );

        setData(res.data.Description);
        setTitle(res.data.Title);
      } catch (error) {
        console.error("Error fetching CMS content:", error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getAllBannerMaster`
      );
      const active = res.data.filter((items) => items.IsActive === true);
      setBanners(active);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setCounted(true);
  }, []);

  const handleInquiry = () => {
    window.open(
      "https://forms.liltriangle.com/enquiry-form/n3CR9rL7ek",
      "_blank"
    );
    setShowModal(false);
  };

  const handleClose = () => setShowModal(false);

  return (
    <>
      {/* ================= BANNER ================= */}
      <section className="banner bg-holder" style={{ overflow: "hidden" }}>
        <Carousel className="main-banner">
          {banners.map((banner, index) => (
            <Carousel.Item key={index}>
              <img
                src={`${process.env.REACT_APP_BASE_API_URL}/${banner.BannerImage}`}
                style={{ height: "500px" }}
                className="d-block w-100"
                alt={banner.title}
              />

              <Carousel.Caption>
                <div className="caption" style={{ textAlign: "left", marginLeft: "100px" }}>
                  <h1 style={{ color: "#fff" }}>{banner.BannerTitle}</h1>
                  <p style={{ fontSize: "25px" }}>
                    {banner.BannerSubTitle}
                  </p>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* ================= ABOUT ================= */}
      <section
        className="bg-img"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div
          className="h-100 about-area"
          style={{ paddingBottom: "0px" }}
        >
          <div className="container">
            <div
              className="row align-items-center"
              style={{
                height: "auto",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                className="col-lg-6 order-lg-1 order-2"
                style={{
                  position: "relative",
                  zIndex: 3,
                }}
              >
                {/* Title, description and Read More button hidden for now
                <div style={{ marginBottom: "60px", marginTop: "40px" }}>
                  <div className="section-title mb-4">
                    <h2 className="title">
                      Welcome&nbsp;to&nbsp;
                      <span className="span-title">
                        Millennium&nbsp;Westbridge&nbsp;School
                      </span>
                    </h2>
                    <p className="lead mb-0 text-justify">
                      {React.createElement("div", {
                        dangerouslySetInnerHTML: { __html: dataDesc },
                      })}
                    </p>
                  </div>
                  <a
                    href="/overview"
                    className="btn btn-primary btn-round"
                    style={{ marginTop: "-2rem" }}
                  >
                    Read More
                  </a>
                </div>
                */}
              </div>

              <div className="col-lg-6 order-lg-2 order-1 pr-lg-5">
                <div className="position-relative pb-md-0 h-100">
                  <img
                    style={{ marginBottom: "0px", display: "block" }}
                    className="img-fluid about-img border-radius"
                    src={ludhianalogo}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= COUNTERS ================= */}
      <section
        className="space-ptb counter-section"
        style={{ paddingTop: "0px", paddingBottom: "0px" }}
      >
        <div className="container">
          <div
            className="row"
            style={{ paddingTop: "70px", paddingBottom: "70px" }}
          >
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <div className="counter">
                <div className="counter-icon">
                  <i className="flaticon-team-1 text-white"></i>
                </div>
                <div className="counter-content">
                  {counted && <CountUp end={50000} duration={10} />}
                  <label className="text-white">Students</label>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <div className="counter">
                <div className="counter-icon">
                  <i className="flaticon-university text-white"></i>
                </div>
                <div className="counter-content">
                  {counted && <CountUp end={20} duration={10} />}
                  <label className="text-white">Schools</label>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4 mb-md-0">
              <div className="counter">
                <div className="counter-icon">
                  <i className="flaticon-experience text-white"></i>
                </div>
                <div className="counter-content">
                  {counted && <CountUp end={1500} duration={10} />}
                  <label className="text-white">Qualified teachers</label>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="counter">
                <div className="counter-icon">
                  <i className="flaticon-trophy-1 text-white"></i>
                </div>
                <div className="counter-content">
                  {counted && <CountUp end={10} duration={10} />}
                  <label className="text-white">Awards</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= STUDY & TESTIMONIAL ================= */}
      <div className="container">
        <Study />
      </div>

      <div className="container">
        <Testimonial />
      </div>

      {/* ================= MODAL ================= */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Admissions Open</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontWeight: "bolder" }}>
            Admissions are now open (2025-2026) for Millennium Westbridge School.
            Click the button below to Enquire.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" onClick={handleInquiry}>
            Enquire
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
